module.exports = __webpack_public_path__ + "img/9a00d6a.png";